import { MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import InputTextField from '../../../../components/input/inputTextField';
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import { swalError, swalSuccess } from '../../../../components/alert/swal';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import FilterSelect from '../../../../components/select/filterSelect';
import { ReactComponent as AddSquare } from '../../../../assets/icons/add-square-green.svg'
import { ReactComponent as Document } from '../../../../assets/icons/document.svg'
import { ReactComponent as Bag } from '../../../../assets/icons/bag-button.svg'
import UploadFile from '../../../../components/upload/UploadFile';
import { routeName } from '../../../../routes/routeName';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { useTranslation } from 'react-i18next';

export default function AddAgenda() {
    const { t } = useTranslation();
    const location = useLocation()
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const id_Agenda = search_params.get("id");
    const mode = search_params.get("mode");
    const { id, idAgenda } = useParams();
    const [listAgendas, setListAgendas] = useState<any[]>([]);

    const [form, setForm] = useState<any>()
    const getListAgendas = async () => {
        const res = await MeetingRoomApi.listAgendas(id);
        const data = res.data
        console.log(data);
        setForm({ ...form, id_meeting_agenda_ref: idAgenda || undefined })
        setListAgendas(data)
    }
    const handleSubmit = async () => {
        const body = {
            id_meeting_agenda_ref: idAgenda || undefined,
            meeting_agenda_name: form?.meeting_agenda_name,
            meeting_agenda_desc: form?.meeting_agenda_desc,
            meeting_agenda_resolution: undefined,
            id_meeting_agenda_file: form?.agenda_file?.id_meeting_agenda_file || undefined
        }

        if (id_Agenda) {
            await MeetingRoomApi.patchAgendas(mode === 'RESOLOTION' ? { meeting_agenda_resolution: form?.meeting_agenda_resolution, id_meeting_agenda_file: form?.agenda_file?.id_meeting_agenda_file || undefined } : body, id, id_Agenda).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(idAgenda ? mode === 'RESOLOTION' ? t('บันทึกมติที่ประชุม') : t('MEETING.SUB_AGENDA_RECORDED') : t('MEETING.MAIN_AGENDA_ADDED'), undefined, undefined, () => {
                        navigate(-1)
                    })

                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        } else {
            await MeetingRoomApi.postAgendas(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(idAgenda ? t('MEETING.SUB_AGENDA_ADDED') : t('MEETING.MAIN_AGENDA_ADDED'), undefined, undefined, () => {
                        navigate(-1)
                    })

                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        }
    }
    useEffect(() => {
        if (id) {
            getListAgendas()
        }
    }, [])
    const getAgendas = async () => {
        await MeetingRoomApi.getAgendas(id, id_Agenda).then((res: any) => {
            if (res.status < 300) {
                setForm(res.data)
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    useEffect(() => {
        if (id_Agenda) {
            getAgendas()
        }
    }, [])
    const handleUpdate = async (file: any) => {

        const formData = new FormData();
        //DRAFT
        formData.append('file', file[0]);
        await MeetingRoomApi.uploadMeetingAgendaFile(formData, id).then((res: any) => {
            if (res.status < 300) {

                setForm({
                    ...form, agenda_file: res.data
                })


            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("MEETING.MEETING_CALENDAR"),
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: t("MEETING.ADD_MEETING"),
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                    {
                        name: mode ? location?.pathname?.includes('add-sub-agenda') ? t('ข้อมูลวาระย่อย') : t('ข้อมูลวาระหลัก') : location?.pathname?.includes('add-sub-agenda') ? t('MEETING.ADD_SUB_AGENDA') : t('MEETING.ADD_MAIN_AGENDA'),
                        key: "3",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{mode ? location?.pathname?.includes('add-sub-agenda') ? t('ข้อมูลวาระย่อย') : t('ข้อมูลวาระหลัก') : location?.pathname?.includes('add-sub-agenda') ? t('MEETING.ADD_SUB_AGENDA') : t('MEETING.ADD_MAIN_AGENDA')}</Typography>
            </section>

            <section className="my-4" style={{ display: 'flex', flexDirection: "column", gap: '10px' }}>
                {location?.pathname?.includes('add-sub-agenda') &&
                    <div>
                        <FilterSelect
                            // value={inputValueSearch.year ?? ""}
                            heading={t('MEETING.UNDER_MAIN_AGENDA')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listAgendas.map((item: any, index: number) => (
                                <MenuItem value={item.id_meeting_agenda} key={index + 1}>
                                    {item.meeting_agenda_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_meeting_agenda_ref: e.target.value })
                            }}
                            value={form?.id_meeting_agenda_ref || ''}
                            disabled={true}
                        />
                    </div>}
                <div>
                    <InputTextField
                        heading={t("MEETING.AGENDA_NAME")}
                        placeholder={t("MEETING.AGENDA_NAME")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setForm({ ...form, meeting_agenda_name: e.target.value })
                        }}
                        value={form?.meeting_agenda_name || ''}
                        disabled={mode ? true : false}

                    />
                </div>
                <div>
                    <InputTextField
                        heading={t("MEETING_CATEGORY.DETAILS")}
                        placeholder={t("MEETING_CATEGORY.SPECIFY_DETAILS")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setForm({ ...form, meeting_agenda_desc: e.target.value })
                        }}
                        value={form?.meeting_agenda_desc || ''}
                        multiline
                        minRow={6}
                        inputHeight={'auto'}
                        disabled={mode ? true : false}
                    // value={inputValueSearch.leave_type_name}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                    <Typography variant='h6'>{t("MEETING.ATTACHED_DOCUMENTS")}</Typography>
                    {/* <AddSquare onClick={() => setForm({ ...form, meeting_agenda_file: form?.meeting_agenda_file?.length > 0 ? [...form?.meeting_agenda_file, {}] : [{}] })} /> */}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', }}>
                    {form?.agenda_file ?
                        <div style={{
                            border: "2px dotted #C1C3C7",
                            borderRadius: "10px",
                            padding: "15px 15px",
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%'
                        }}>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Document />
                                <div style={{ display: "flex", alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{form?.agenda_file?.file_name}</Typography>
                                    {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                                </div>
                            </div>

                            <ButtonOutlined
                                onClick={() => {
                                    // handleSubmit(inputValueFormStudent.information);
                                    window.open(process.env.REACT_APP_FILE_BASE_API + '/' + form?.agenda_file?.file_path + form?.agenda_file?.file_name, '_blank');

                                }}
                                buttonName={t("MEETING.DOWNLOAD_FILE")}
                                btnProps={{
                                    width: "150px",
                                    // border: '#0F9F0C'
                                }}
                            />
                        </div> :
                        <UploadFile
                            onDrop={(file) => {
                                handleUpdate(file);
                            }}
                            // enableFormatImage
                            onDeleteFile={() => {
                                // setFile(null);
                            }}
                            noClick={mode ? true : false}

                        // formatText='ขนาดไม่เกิน 10MB'
                        // customFormat={["image/jpeg", "image/jpg", "image/png"]}

                        />}
                    {!mode && <div style={{
                        border: '1px solid #DDE1EB',
                        borderRadius: '8px',
                        padding: '16px',
                        cursor:'pointer'
                    }} onClick={() => {
                        setForm({
                            ...form, agenda_file: null
                        })
                    }}>
                        <Bag />
                    </div>}
                </div>
            </section>
            {mode === 'RESOLOTION' && <div className=''>
                <div className='border-2 border-dashed my-8 w-full'>

                </div>
                <Typography variant='h4'>{t("มติที่ประชุม")}</Typography>
                <InputTextField
                    heading={''}
                    placeholder={t('มติที่ประชุมสรุปได้ว่า....')}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        // handleChangeValueSearch("leave_type_name", e.target.value);
                        setForm({ ...form, meeting_agenda_resolution: e.target.value })
                    }}
                    value={form?.meeting_agenda_resolution || ''}
                    multiline
                    minRow={6}
                    inputHeight={'auto'}
                // disabled={mode ? true : false}
                // value={inputValueSearch.leave_type_name}
                />
            </div>}

            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(-1);
                    }}
                    buttonName={t("ย้อนกลับ")}
                    btnProps={{
                        width: "150px",
                    }}
                />


                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        handleSubmit()
                    }}
                    disabled={!form?.meeting_agenda_name}
                    mode="success"
                    buttonName={t("ยืนยัน")}
                    btnProps={{
                        width: "150px",
                    }}
                />}
            </section>
        </div>
    )
}
